import {ChangeEventHandler, CSSProperties, useContext, useState} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {HostContext} from "@components/host/HostProvider";
import {GameContext} from "@components/game/GameProvider";
import {THEME} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    alert: {
        ...THEME.text,
        backgroundColor: "red",
        borderRadius: 9,
        color: "white",
        fontWeight: "bold",
        minWidth: 18,
        textAlign: "center"
    },
    contents: {
        display: "flex",
        flexDirection: "column",
        margin: 4
    }
};
interface IEmailPasswordLogin {
    onSuccess?: () => void
}

export function EmailPasswordLogin({onSuccess}: IEmailPasswordLogin) {
    const game = useContext(GameContext);
    const host = useContext(HostContext)
    const [input, setInput] =
        useState<Record<string, string>>({})
    const [loggingIn, setLoggingIn] = useState(false);
    const handleCancel = () => {
        setInput(input => ({...input, email: "", password: ""}));
    }
    const handleLogin = () => {
        setLoggingIn(true);
        game.logIn(input["email"], input["password"]).then(() => {
            return game.initialiseUserPlayer();
        }).then(() => {
            setInput(input => ({...input, email: "", password: ""}));
            onSuccess?.();
        }).catch(error => {
                if (error.code === 101) {
                    setInput(input => ({...input, wrongPassword: input.password}));
                }
            })
            .finally(() => setLoggingIn(false));
    }
    const handleResetPassword = () => {
        host.resetPassword(input.email).then(reset => {
            if (reset) {
                setInput(input => ({...input, email: "", password: ""}));
            }
        });
    }

    const handleInputChange = (key: string):ChangeEventHandler<HTMLInputElement> =>
        ({target}) =>
            setInput(input => ({...input, [key]: target.value}));
    const emailWellFormed = input["email"]?.match(/\w+@\w+\.\w+/);
    const passwordWellFormed = input["password"]?.length >= 8 && input["password"] !== input["wrongPassword"];
    const cancelEnabled = (input["confirm"] && input["confirm"].length !== 0) ||
        (input["password"] && input["password"].length !== 0) || (input["email"] && input["email"].length !== 0);

    return (
        <div style={styles.contents}>
            <div style={styles.labelledInput}>
                <div style={styles.label}>
                    <LocalisedTypography content="AuthenticationLabelEmail"/>
                </div>
                <input autoComplete="username" onChange={handleInputChange("email")}
                       style={styles.input} value={input["email"] || ""}/>
            </div>
            <div style={styles.labelledInput}>
                <div style={styles.label}>
                    <LocalisedTypography content="AuthenticationLabelPassword" />
                </div>
                {input["password"]?.length > 0 && input["password"] === input["wrongPassword"] &&
                    <div style={styles.alert}>!</div>
                }
                <input autoComplete="current-password" onChange={handleInputChange("password")}
                       style={styles.input} type="password" value={input["password"] || ""}/>
            </div>
            <div style={styles.buttons}>
                <button disabled={!cancelEnabled} onClick={handleCancel}
                        style={styles.button}>
                    <LocalisedTypography content="AuthenticationCancel"/>
                </button>
                <button disabled={!emailWellFormed} onClick={handleResetPassword}
                        style={styles.button}>
                    <LocalisedTypography content="AuthenticationResetPassword"/>
                </button>
                <button disabled={!emailWellFormed || !passwordWellFormed || loggingIn} onClick={handleLogin}
                        style={styles.button}>
                    <LocalisedTypography content={loggingIn ? "AuthenticationLoggingIn" : "AuthenticationLogin"}/>
                </button>
            </div>
            {game.initialisationError && <div style={styles.paragraph}>
                <LocalisedTypography content={game.initialisationError.message}/>
            </div>}
        </div>
    );
}